module.exports = __webpack_public_path__ + "static/media/7-gratt.55a75fb6.mp3";